import Vue from "vue";
import Vuex from "vuex";
import getters from "./getters";
import settings from "./modules/settings";
import page from "./modules/page";
import user from "./modules/user";
import limit from "./modules/limit";
import conflict from "./modules/conflict";

Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    settings,
    page,
    user,
    limit,
    conflict,
  },
  getters
});

export default store;
